(function () {
  if (window.__lgBraceletLengthOptions) return;
  window.__lgBraceletLengthOptions = true;

  var COLLECTION_HANDLE = 'diamond-bracelets';
  var ENGRAVING_PLACEHOLDER = 'Add a meaningful message to your bracelet';
  var LENGTHS = [
    '6.0" – Extra Small Wrist',
    '6.5" – Small Wrist',
    '7.0" – Standard Women\'s Size (Most Popular)',
    '7.5" – Comfortable Fit',
    '8.0" – Large Wrist',
    '8.5" – Extra Large Wrist'
  ];
  var retryTimer = null;

  function isDiamondBraceletProduct() {
    if (!document.body || !document.body.classList.contains('template-product')) return false;
    var collections = (document.body.getAttribute('data-lg-product-collections') || '').split(',');
    return collections.indexOf(COLLECTION_HANDLE) !== -1;
  }

  function findProductForm() {
    return document.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"], .t4s-form__product');
  }

  function hasBraceletLengthOption(form) {
    if (form.querySelector('[data-lg-bracelet-length-option], [name="properties[Bracelet Length]"]')) return true;

    var candidates = document.querySelectorAll('label, legend, h3, h4, [class*="label"], [class*="title"]');
    for (var i = 0; i < candidates.length; i += 1) {
      var text = (candidates[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/select\s*bracelet\s*length|bracelet length/i.test(text)) return true;
    }
    return false;
  }

  function findEngravingInput(form) {
    return form.querySelector('[name="properties[Complimentary Engraving]"]');
  }

  function ensureStyle() {
    if (document.getElementById('lg-bracelet-length-options-style')) return;

    var style = document.createElement('style');
    style.id = 'lg-bracelet-length-options-style';
    style.textContent = [
      '.lg-bracelet-length-option{margin:10px 0 18px}',
      '.lg-bracelet-length-option__label,.lg-bracelet-engraving__label{display:block;margin:0 0 8px;color:#222;font-size:14px;font-weight:500;line-height:1.4}',
      '.lg-bracelet-length-option__select{display:block;width:100%;height:48px;min-height:48px;padding:0 16px;border:1px solid #d8d1c3;border-radius:0;background:#fff;color:#222;font-size:14px;font-weight:500;line-height:1.4;box-shadow:none;cursor:pointer}',
      '.lg-bracelet-length-option__select:hover,.lg-bracelet-length-option__select:focus{border-color:#8a6a2f;outline:none}',
      '.lg-bracelet-engraving{margin:10px 0 22px}',
      '.lg-bracelet-engraving__input{display:block;width:100%;height:48px;min-height:48px;padding:0 16px;border:1px solid #d8d1c3;border-radius:0;background:#fff;color:#222;font-size:14px;font-weight:400;line-height:48px;box-shadow:none}',
      '.lg-bracelet-engraving__input:hover,.lg-bracelet-engraving__input:focus{border-color:#8a6a2f;outline:none}',
      '.lg-bracelet-engraving__input::placeholder{color:#6d6d6d;opacity:1}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function createBraceletLengthOption(form) {
    var wrapper = document.createElement('div');
    wrapper.className = 'lg-bracelet-length-option';
    wrapper.setAttribute('data-lg-bracelet-length-option', '');

    var label = document.createElement('label');
    label.className = 'lg-bracelet-length-option__label';
    label.setAttribute('for', 'lg-bracelet-length-select');
    label.textContent = 'Select Bracelet Length:';

    var select = document.createElement('select');
    select.id = 'lg-bracelet-length-select';
    select.className = 'lg-bracelet-length-option__select';
    select.name = 'properties[Bracelet Length]';

    LENGTHS.forEach(function (length) {
      var option = document.createElement('option');
      option.value = length;
      option.textContent = length;
      select.appendChild(option);
    });

    wrapper.appendChild(label);
    wrapper.appendChild(select);

    var buttons = form.querySelector('.t4s-product-form__buttons');
    var metalColor = form.querySelector('[data-lg-metal-color-option]');
    var variants = form.querySelector('.t4s-swatch');

    if (metalColor && metalColor.parentNode) metalColor.insertAdjacentElement('afterend', wrapper);
    else if (variants && variants.parentNode) variants.insertAdjacentElement('afterend', wrapper);
    else if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(wrapper, buttons);
    else form.appendChild(wrapper);

    return wrapper;
  }

  function ensureEngravingOption(form, lengthOption) {
    var existingInput = findEngravingInput(form);
    if (existingInput) {
      existingInput.disabled = false;
      existingInput.placeholder = ENGRAVING_PLACEHOLDER;
      var existingWrapper = existingInput.closest('.luminary-engraving-field, .lg-bracelet-engraving');
      if (existingWrapper) existingWrapper.hidden = false;
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'lg-bracelet-engraving';
    wrapper.setAttribute('data-lg-bracelet-engraving', '');

    var label = document.createElement('label');
    label.className = 'lg-bracelet-engraving__label';
    label.setAttribute('for', 'lg-bracelet-engraving-input');
    label.textContent = 'Complimentary Engraving:';

    var input = document.createElement('input');
    input.id = 'lg-bracelet-engraving-input';
    input.className = 'lg-bracelet-engraving__input';
    input.type = 'text';
    input.name = 'properties[Complimentary Engraving]';
    input.maxLength = 80;
    input.placeholder = ENGRAVING_PLACEHOLDER;

    wrapper.appendChild(label);
    wrapper.appendChild(input);

    var lengthWrapper = lengthOption || form.querySelector('[data-lg-bracelet-length-option]');
    var buttons = form.querySelector('.t4s-product-form__buttons');

    if (lengthWrapper && lengthWrapper.parentNode) lengthWrapper.insertAdjacentElement('afterend', wrapper);
    else if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(wrapper, buttons);
    else form.appendChild(wrapper);
  }

  function initBraceletOptions() {
    if (!isDiamondBraceletProduct()) return;
    var form = findProductForm();
    if (!form) return;

    ensureStyle();

    var lengthOption = form.querySelector('[data-lg-bracelet-length-option]');
    if (!hasBraceletLengthOption(form)) lengthOption = createBraceletLengthOption(form);
    ensureEngravingOption(form, lengthOption);
  }

  function scheduleInit() {
    var attempts = 0;
    if (retryTimer) clearInterval(retryTimer);
    initBraceletOptions();
    retryTimer = setInterval(function () {
      attempts += 1;
      initBraceletOptions();
      if (attempts >= 20) clearInterval(retryTimer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleInit);
  else scheduleInit();
  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('tpo_loaded', scheduleInit);
  document.addEventListener('easify:loaded', scheduleInit);
})();
